/*
 * Copyright (C) 2026 Fluxer Contributors
 *
 * This file is part of Fluxer.
 *
 * Fluxer is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * Fluxer is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with Fluxer. If not, see <https://www.gnu.org/licenses/>.
 */

import type {IconProps} from '@phosphor-icons/react';
import React from 'react';

export const NSFWVoiceChannelIcon = React.forwardRef<SVGSVGElement, IconProps>(
	({size = 256, className, ...props}, ref) => (
		<svg
			ref={ref}
			width={size}
			height={size}
			viewBox="0 0 256 256"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			aria-hidden={true}
			{...props}
		>
			<path
				fill="currentColor"
				d="m245.254 92.0979-34.16-59.3242c-.854-1.4534-2.072-2.6585-3.535-3.4959C206.096 28.4405 204.44 28 202.754 28c-1.685 0-3.342.4405-4.805 1.2778-1.462.8374-2.681 2.0425-3.535 3.4959l-34.16 59.3242c-.821 1.4058-1.254 3.0047-1.254 4.6328 0 1.6282.433 3.227 1.254 4.6333.843 1.462 2.059 2.673 3.525 3.51s3.127 1.269 4.815 1.251h68.32c1.687.016 3.347-.416 4.811-1.253s2.679-2.047 3.521-3.508c.823-1.4056 1.257-3.0041 1.258-4.6322.002-1.6282-.43-3.2274-1.25-4.6339m-45.625-32.8476c0-.8288.329-1.6237.915-2.2097.587-.5861 1.381-.9153 2.21-.9153s1.624.3292 2.21.9153c.586.586.915 1.3809.915 2.2097v15.625c0 .8288-.329 1.6236-.915 2.2097-.586.586-1.381.9153-2.21.9153s-1.623-.3293-2.21-.9153c-.586-.5861-.915-1.3809-.915-2.2097zm3.125 34.375c-.927 0-1.833-.275-2.604-.79-.771-.5151-1.372-1.2472-1.726-2.1037-.355-.8565-.448-1.799-.267-2.7083s.627-1.7445 1.283-2.4001c.655-.6556 1.49-1.102 2.4-1.2829.909-.1808 1.851-.088 2.708.2668s1.589.9556 2.104 1.7264c.515.7709.79 1.6772.79 2.6043 0 1.2432-.494 2.4354-1.373 3.3145s-2.072 1.373-3.315 1.373M116.693 32.0001C126.763 21.9201 144 29.056 144 43.3067V212.693c0 14.251-17.237 21.387-27.317 11.307l-48.0003-48H48.0958c-12.1706 0-24.725-7.094-28.3623-20.32-2.4427-8.821-3.7334-18.101-3.7334-27.68-.0115-9.351 1.237-18.663 3.7119-27.681 3.6481-13.2365 16.2026-20.3188 28.373-20.3189h20.6084zM239.881 123c1.351 28.254-8.764 56.956-30.345 78.536-1.516 1.413-3.522 2.182-5.595 2.146-2.072-.037-4.049-.876-5.515-2.342s-2.305-3.443-2.342-5.516c-.036-2.072.733-4.078 2.146-5.594 8.172-8.172 14.656-17.874 19.079-28.551 4.423-10.678 6.699-22.122 6.699-33.679 0-1.67-.049-3.337-.144-5zM199.812 123c.13 1.661.196 3.329.196 5 0 8.406-1.656 16.729-4.873 24.494-3.217 7.766-7.932 14.822-13.876 20.765-1.51 1.456-3.531 2.261-5.628 2.242-2.098-.019-4.104-.861-5.587-2.345s-2.323-3.491-2.34-5.589c-.017-2.097.79-4.117 2.248-5.626 4.457-4.457 7.993-9.748 10.405-15.572 2.413-5.823 3.654-12.066 3.654-18.369 0-1.673-.09-3.342-.264-5z"
			/>
		</svg>
	),
);
